/* eslint-disable */

<template>
  <div>
    <div class="vx-row">
      <!-- ── Left column: questions ── -->
      <div class="vx-col lg:w-4/12 w-full">
        <!-- Q1: Tab 1 command -->
        <vx-card class="mb-4">
          <h4 class="font-medium mb-3">Select the command that generated the output in tab 1:</h4>
          <div :style="selectStyle(tab1Command, correctTab1, gradedTab1)">
            <v-select v-model="tab1Command" :options="commandOptions" placeholder="Select command" />
          </div>
        </vx-card>

        <!-- Q2: Tab 2 command -->
        <vx-card class="mb-4">
          <h4 class="font-medium mb-3">Select the command that generated the output in tab 2:</h4>
          <div :style="selectStyle(tab2Command, correctTab2, gradedTab2)">
            <v-select v-model="tab2Command" :options="commandOptions" placeholder="Select command" />
          </div>
        </vx-card>

        <!-- Q3: Malicious file -->
        <vx-card>
          <h4 class="font-medium mb-4">Identify the file responsible for the malicious behavior:</h4>
          <div class="grid grid-cols-2 gap-3">
            <vs-radio
              v-for="file in fileOptions"
              :key="file"
              v-model="maliciousFile"
              :vs-value="file"
              vs-name="fileSelect"
              :color="radioColor"
              class="mb-1"
            >
              {{ file }}
            </vs-radio>
          </div>
        </vx-card>
      </div>

      <!-- ── Right column: terminal tabs ── -->
      <div class="vx-col lg:w-8/12 w-full">
        <vx-card>
          <!-- Tab buttons inside the card -->
          <div class="flex gap-2 mb-4">
            <vs-button v-for="n in 4" :key="n" :color="activeTab === n ? 'primary' : 'grey'" type="filled" @click="activeTab = n">{{
              n
            }}</vs-button>
          </div>

          <!-- ── Tab 1: netstat -bo ── -->
          <div v-show="activeTab === 1" class="terminal-block">
            <pre class="text-success font-bold terminal-pre">
Active Connections

Proto    Local address              Foreign address           State           PID
TCP      0.0.0.0:22                 0.0.0.0:0                 LISTENING       1000
TCP      0.0.0.0:23                 0.0.0.0:0                 LISTENING       1235
TCP      0.0.0.0:443                0.0.0.0:0                 LISTENING       1466
TCP      0.0.0.0:80                 0.0.0.0:0                 LISTENING       1566
TCP      127.0.0.1:1960             127.0.0.1:22              ESTABLISHED     2001

[sftp.exe]
TCP      192.168.10.21:38666        41.21.18.102:22           ESTABLISHED     3918

[sftp.exe]
TCP      192.168.10.21:8447         66.207.110.49:https       ESTABLISHED     2677

[svchost.exe]
TCP      192.168.10.21:55356        31.10.100.7:https         ESTABLISHED     3467

[cmd.exe]
TCP      192.168.10.21:37654        192.168.10.37:http        ESTABLISHED     1722
TCP      192.168.10.21:55357        32.111.16.37:22           TIME_WAIT       0

[notepad.exe]
TCP      192.168.10.21:52744        32.111.16.37:22           TIME_WAIT       0
TCP      192.168.10.21:56751        32.111.16.37:22           TIME_WAIT       0</pre
            >
          </div>

          <!-- ── Tab 2: tasklist ── -->
          <div v-show="activeTab === 2" class="terminal-block">
            <pre class="text-success font-bold terminal-pre">
Image Name            PID      Session Name      Session#    Mem Usage
--------------------  -------  ----------------  ----------  -----------
cmd.exe               3467     Console           0           18,020 K
sftp.exe              2001     Console           0           17 K
sftp.exe              3918     Console           0           1,788 K
svchost.exe           2677     Console           0           188 K
calc.exe              1677     Console           0           11 K
notepad.exe           -        Console           0           0 K</pre
            >
          </div>

          <!-- ── Tab 3: Get-ChildItem | Get-FileHash -Algorithm MD5 ── -->
          <div v-show="activeTab === 3" class="terminal-block">
            <pre class="text-success font-bold terminal-pre">
> Get-ChildItem | Get-FileHash -Algorithm MD5

Algorithm    Hash                                      File
---------    --------------------------------          ------------
MD5          372ab227fd5ea779c211a1451881d1e1          cmd.exe
MD5          173ab22a5d5ea87bb212c14588aad4c2          calc.exe
MD5          412aba2efd5ea769c2112b451881affe7         explorer.exe
MD5          df6ab147fd5ecb79c331a146f8dad199          users.txt
MD5          212ac257fd5ea7f9c337ba22bab1d1f5          calendar.dat
MD5          10ad132ffed0217c6c3854a22bab215c6         sftp.exe
MD5          33c141f5ed107bcdd39952d2ba111401          svchost.exe</pre
            >
          </div>

          <!-- ── Tab 4: Baseline hash signatures ── -->
          <div v-show="activeTab === 4" class="terminal-block">
            <pre class="text-success font-bold terminal-pre">
The baseline hash signatures are:

Hash                                      File
----------------------------------------  ------------------
a2cdef1c445d3890cc3456789058cd21          cmd.exe
555a1bba5d5e6eebb21fe12388ab3221          calc.exe
412aba2efd5ea769c2112b451881affe7         explorer.exe
90521cc7fd5ea7f9c337ba210eedd1c1          users.txt
3ab21266fd00a7c6c3854a22bab215ba          calendar.dat
10ad132ffed0217c6c3854a22bab215c6         sftp.exe
33c141f5ed107bcdd39952d2ba111401          svchost.exe</pre
            >
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import vSelect from 'vue-select';
import shuffle from 'shuffle-array';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      activeTab: 1,

      tab1Command: null,
      tab2Command: null,
      maliciousFile: null,

      gradedTab1: false,
      gradedTab2: false,
      gradedFile: false,

      commandOptions: shuffle(['net stop', 'nslookup', 'netstat -bo', 'arp -a', 'ipconfig /reset', 'tasklist', 'taskkill /FI', 'cmd']),

      fileOptions: ['cmd.exe', 'calc.exe', 'explorer.exe', 'users.txt', 'sftp.exe', 'svchost.exe', 'calendar.dat'],

      correctTab1: 'netstat -bo',
      correctTab2: 'tasklist',
      correctFile: 'sftp.exe',
    };
  },

  computed: {
    radioColor() {
      if (!this.gradedFile || !this.maliciousFile) return 'primary';
      return this.maliciousFile === this.correctFile ? 'success' : 'danger';
    },
  },

  watch: {
    tab1Command() {
      this.gradedTab1 = false;
    },
    tab2Command() {
      this.gradedTab2 = false;
    },
    maliciousFile() {
      this.gradedFile = false;
    },
  },

  methods: {
    selectStyle(answer, correct, graded) {
      if (!graded || !answer) return 'border-radius: 4px;';
      if (answer === correct) return 'border-radius: 4px; box-shadow: 0 0 0 2px #28C76F;';
      return 'border-radius: 4px; box-shadow: 0 0 0 2px #EA5455;';
    },

    markSimulation() {
      let score = 0;
      this.gradedTab1 = true;
      this.gradedTab2 = true;
      this.gradedFile = true;

      if (this.tab1Command === this.correctTab1) score++;
      if (this.tab2Command === this.correctTab2) score++;
      if (this.maliciousFile === this.correctFile) score++;

      this.$emit('simulation_update_score', score);

      if (score === 3) return this.$emit('simulation_full_correct', score);
      this.$emit('simulation_getting_there', score);
    },
  },

  components: { vSelect },

  props: {
    data: { type: Object, required: true },
  },
};
</script>

<style>
.terminal-block {
  background-color: #000;
  border-radius: 0.5rem;
  overflow-x: auto;
}

.terminal-pre {
  margin: 0;
  padding: 1.25rem 1.5rem;
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.85em;
  line-height: 1.7;
  white-space: pre;
  background: transparent;
}
</style>
